<template>
    <div>
        <Breadcrumbs main="Beacon" title="Member" />

        <div class="container-fluid">
            <div class="d-flex justify-content-end m-3">
                <b-button variant="primary" class="btn-pill" @click="openModal('Add')">
                    <i class="icofont icofont-plus-circle"></i> Add New</b-button>
            </div>
            <ValidationObserver v-slot="{ invalid }">
                <b-modal :hide-footer="modalData.title == 'View'" content-class="rounded-1" v-model="show" body-class="p-4"
                    centered :title="`${modalData.title} Member`">
                    <div class="row">
                        <div v-for="(form, i) in form" :key="i" :class="`col-${form.col}`">
                            <ValidationProvider :name="form.name" :rules="form.validate ? form.rule : ''"
                                v-slot="{ errors }">
                                <b-form-group :label="form.name" :label-for="form.name">
                                    <template #description>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </template>
                                    <v-select v-if="form.type.match('select')" :id="form.name" :disabled="modalData.disable"
                                        v-model="form.value" label="name" :options="company"></v-select>
                                    <b-form-textarea v-else-if="form.type.match('text-area')" v-model="form.value" rows="3"
                                        :disabled="modalData.disable" :id="form.name"></b-form-textarea>
                                    <b-form-input v-else :disabled="modalData.disable" :id="form.name"
                                        v-model="form.value"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                    </div>
                    <template #modal-footer>
                        <b-button variant="primary" :disabled="invalid" @click="save(modalData)"><i class="fa fa-save"></i>
                            Save
                        </b-button>
                    </template>
                </b-modal>
            </ValidationObserver>

            <div class="card p-4">
                <dataTableVue ref="refDataTable" :isSearch="false" :isFilter="true" :isImport="true" :isExport="true"
                    v-bind:data="{
                                            module: 'beacon',
                                            columns: columns,
                                            rows: rows,
                                            exportDetail: exportDetail,
                                            importDetail: importDetail,
                                            filter_custom: 'filterCustomMember',
                                        }" @load="loadItems" @openModal="openModal" @deleteRow="deleteRow" />
            </div>
        </div>
    </div>
</template>

<script>
import { requestService } from './../../_services';

export default {
    data() {
        return {
            company: [],
            modalData: {
                title: null,
                disable: false,
                row: null,
            },
            show: false,
            form: [
                {
                    value: '',
                    col: 6,
                    name: 'First Name',
                    type: 'input',
                    validate: true,
                    rule: 'required|customRegex|customRegexCRLF|max_length200'
                },
                {
                    value: '',
                    col: 6,
                    name: 'Last Name',
                    type: 'input',
                    validate: true,
                    rule: 'required|customRegex|customRegexCRLF|max_length200'
                },
                {
                    value: '',
                    col: 6,
                    name: 'Email',
                    type: 'input',
                    validate: true,
                    rule: 'email|customRegexCRLF|max_length200'
                },
                {
                    value: '',
                    col: 6,
                    name: 'Phone',
                    type: 'input',
                    validate: true,
                    rule: 'customRegex|customRegexCRLF|digits:10'
                },
                {
                    value: '',
                    col: 12,
                    name: 'Company',
                    type: 'select',
                    validate: true,
                    rule: 'customRegex|customRegexCRLF|max_length200'
                },
                {
                    value: '',
                    col: 12,
                    name: 'Description',
                    type: 'text-area',
                    validate: true,
                    rule: 'customRegex|max_length200'
                },
            ],
            columns: [
                {
                    label: 'First Name',
                    field: 'first_name',
                    hidden: false,
                },
                {
                    label: 'Last Name',
                    field: 'last_name',
                    hidden: false,
                },
                {
                    label: 'Company',
                    field: 'company_name',
                    hidden: false,
                },
                {
                    label: 'Com Code',
                    field: 'company_code',
                    hidden: false,
                },
                {
                    label: 'BU',
                    field: 'company_bu',
                    hidden: false,
                },
                {
                    label: 'Phone',
                    field: 'phone',
                    hidden: false,
                },
                {
                    label: 'Email',
                    field: 'email',
                    hidden: false,
                },
                {
                    label: 'Action',
                    field: 'action',
                    thClass: 'custom-th-class',
                    hidden: false,
                },
            ],
            rows: [],
            exportDetail: {
                fileName: 'export_member',
                exportUrl: '',
            },
            importDetail: {
                importField: [
                    {
                        key: 'first_name',
                        isFind: null,
                    },
                    {
                        key: 'last_name',
                        isFind: null,
                    },
                    {
                        key: 'email',
                        isFind: null,
                    },
                    {
                        key: 'phone',
                        isFind: null,
                    },
                    {
                        key: 'description',
                        isFind: null,
                    },
                    {
                        key: 'company_name',
                        isFind: null,
                    },
                ],
                importUrl: '/api/member/import/all',
            },
        };
    },
    watch: {
        show(newValue, oldValue) {
            if (oldValue) {
                this.form.map((item, i) => {
                    this.form[i].value = '';
                });
            }
        },
    },
    async mounted() {
        // this.loadColumn();
        await this.loadItems();
        await this.getCompany();
    },
    methods: {
        deleteRow(value) {
            const url = `/api/member/${value.row._id}`;
            this.$swal
                .fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2971FF',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        requestService
                            .DeleteFetch('beacon', url)
                            .then(() => {
                                this.$swal.fire(
                                    'Deleted!',
                                    'Your file has been deleted.',
                                    'success'
                                );
                                this.loadItems();
                            }).catch((err) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: 'Try Again',
                                    text: err,
                                });
                            });
                    }
                });
        },
        save(value) {
            let data = this.form.map((item) => item.value);
            this.show = !this.show;
            const url = `/api/member${value.title.match('Edit') ? '/' + value.row.row._id : ''
                }`;
            const object = {
                first_name: data[0],
                last_name: data[1],
                email: data[2],
                phone: data[3],
                company_id: data[4]._id,
                description: data[5],
            };

            requestService
                .PostFetch('beacon', url, object)
                .then(() => {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Member has been saved',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    this.form.map((item, i) => {
                        this.form[i].value = '';
                    });
                    this.loadItems();
                })
                .catch((err) => {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Try Again',
                        text: err,
                        filterParam: '',
                    });
                });
        },
        async getCompany() {
            let url = `/api/company/all`;
            const resCompany = await requestService.GetFetch('beacon', url);
            const company = await resCompany.json();
            this.company = company.data;
        },
        openModal(value, id) {
            this.modalData.title = value;
            this.modalData.row = id;
            this.show = !this.show;
            if (!value.match('Add')) {
                this.form[0].value = id.row.first_name;
                this.form[1].value = id.row.last_name;
                this.form[2].value = id.row.email;
                this.form[3].value = id.row.phone;
                this.form[4].value = {
                    _id: id.row.company_id,
                    name: id.row.company_name,
                };
                this.form[5].value = id.row.description;
            }
            value.match('View')
                ? (this.modalData.disable = true)
                : (this.modalData.disable = false);
        },
        async loadItems(event) {
            var str = '';
            if (event != undefined) {
                for (var key in event.params) {
                    if (str != '') {
                        str += '&';
                    }
                    str += key + '=' + encodeURIComponent(event.params[key]);

                }
                if (event.sortField != undefined) {
                    if (event.sortField == "") {
                        if (str != '') {
                            str += '&';
                        }
                        str += "sortField=first_name"
                    } else {
                        this.columns.forEach((element) => {
                            if (event.sortField == element.field) {
                                if (
                                    event.sortField == 'created_at' ||
                                    event.sortField == 'updated_at'
                                ) {
                                    str += '&' + 'sortField=' + event.sortField;
                                } else {
                                    str += '&' + 'sortField=' + element.field;
                                }
                            }
                        });
                    }

                } else {
                    if (str != '') {
                        str += '&';
                    }
                    str += "sortField=first_name"
                }
                if (event.filter != undefined) {
                    for (var key in event.filter) {
                        if (str != '') {
                            str += '&';
                        }
                        str += key + '=' + encodeURIComponent(event.filter[key]);
                    }
                }
            } else {
                str += "sortField=first_name"
            }
            this.exportDetail.exportUrl = '/api/member/export?' + str;
            var url = '/api/member/filter?' + str;
            return requestService.GetFetch('beacon', url)
                .then((response) => {
                    if (response.status == 200) {
                        response.text().then((text) => {
                            let self = this;
                            self.rows = [];
                            const data = text && JSON.parse(text);

                            if (data.data.data != null) {
                                self.json_data = data.data.data;
                                self.rows = data.data.data;
                                self.$refs.refDataTable.setTotalRecords(data.data.total);
                                self.$refs.refDataTable.setPages(data.data.current_page);
                            } else {
                                self.$refs.refDataTable.setTotalRecords(0);
                                self.$refs.refDataTable.setPages(1);
                            }
                        });
                    }
                })
                .catch((error) => {
                    this.$notify({ text: error, type: 'danger' });
                });
        },
        // async exportItems(){
        //     this.exportDetail.exportData=[]
        //     this.filterParam=str
        //     var url = '/api/member/export?' + this.filterParam;
        //     return requestService.GetFetch(url).then((response) => {
        //         if (response.status == 200) {
        //             response.text().then((text) => {
        //               let self = this;
        //               const data = text && JSON.parse(text);
        //               if (data.data.data != null) {
        //                   self.exportDetail.exportData=data.data.data
        //                   self.$refs.refDataTable.clkExport()
        //               }
        //             });
        //         }
        //     }).catch((error) => {
        //       console.log(error);
        //     });

        // }
    },
};
</script>

<style></style>
